import type { JSONNode } from '@atlaskit/editor-json-transformer';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export type SelectionContext = {
	/**
	 * Local IDs of the selected nodes
	 */
	localIds: string[] | null;
	/**
	 * Prosemirror fragment of the selection converted to JSONNode array
	 *
	 * Note that this is a direct Prosemirror Fragment and has some slight tweaks
	 * so it performs better with AI models (e.g. reduced depth to reduce token count).
	 */
	selectionFragment: JSONNode[] | null;
	/**
	 * Selection in markdown format
	 */
	selectionMarkdown: string | null;
};

export type SelectionPluginState = {
	// Whether we are pending clearing the `lastSelectionContext` due to a "handoff"
	isPendingSelectionContextClear: boolean;
	lastSelectionContext: SelectionContext | undefined;
	nonCursorSelectionChangeCount: number;
};

export const selectionPluginKey = new PluginKey<SelectionPluginState>('aiExperienceSelection');
